import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadContractorVisit } from "@/types/contractorVisit";
import { NetworkDetector } from "@/services/networkDetector";
import { OfflineQueue } from "@/services/offlineQueue";

const service = new APIService<ReadContractorVisit>(
  API.ContractorPanelVisits,
  OfflineQueue,
  NetworkDetector,
);

export type CompleteVisitData = Pick<
  ReadContractorVisit,
  | "confirmation_latitude"
  | "confirmation_longitude"
  | "device_type"
  | "confirmation_geolocation_accuracy"
> & {
  start_datetime?: ReadContractorVisit["start_datetime"];
  end_datetime?: ReadContractorVisit["end_datetime"];
};

export const ContractorPanelVisitService = {
  getList: (params?: Parameters<typeof service.getList>[0]) => {
    return service.getList(params);
  },
  initializeVisit: (
    visitId: string,
    data: Pick<
      ReadContractorVisit,
      | "start_datetime"
      | "start_latitude"
      | "start_longitude"
      | "device_type"
      | "start_geolocation_accuracy"
    >,
  ) => {
    return service.patch(visitId, data, "start");
  },
  completeVisit: (visitId: string, data: CompleteVisitData) => {
    return service.patch(visitId, data, "complete");
  },
  getVisit: (visitId: string) => {
    return service.get(visitId);
  },
};
